import React, { useEffect, useRef, useState } from "react";
import ResourceCard from "@features/resources/components/ResourceCard";
import { useResourceStore } from "@shared/stores";
import FindAvailableTime from "@features/search/components/FindAvailableTime";
import NavigateSearch from "@features/search/components/NavigateSearch";
import VStack from "@components/layout/VStack";
import useScrollShadow from "@shared/hooks/useScrollShadow";
import TitlePage from "@components/layout/TitlePage";
import { titlePages } from "@shared/constants/appConstants";
import { useTranslation } from "react-i18next";
import SelectMeetingType from "../components/SelectMeetingType";
import { useOutlookActions } from "@/pages/taskpane/lib/office/hooks";

const SelectedResources = () => {
  const { t } = useTranslation();
  const { selectedResource } = useResourceStore();

  const listRef = useRef<HTMLDivElement | null>(null);
  const { getSessionId } = useOutlookActions();
  const [orderFormSessionId, setOrderFormSessionId] = useState<Record<string, boolean | undefined>>({});

  useEffect(() => {
    if (selectedResource.length > 0) {
      selectedResource.forEach((resource) => {
        if (!resource.isOrdered) {
          getSessionId(resource.email?.toLowerCase()).then((sessionId) => {
            setOrderFormSessionId((prev) => ({ ...prev, [resource.email?.toLowerCase()]: sessionId.includes("_save_ordered") }));
          });
        }
      });
    } else {
      setOrderFormSessionId({});
    }
  }, [selectedResource]);

  useScrollShadow(listRef);

  return (
    <VStack className="h-full">
      <VStack className="px-4 pt-1 pb-4 flex-1 overflow-hidden" gap={3}>
        {/* Title */}
        <TitlePage title={t(titlePages.selectedResources.title)} />

        {/* List Selected Resources */}
        <VStack ref={listRef} className="max-h-full overflow-y-auto no-scrollbar" gap={2}>
          {selectedResource.map((resource) => (
            <ResourceCard
              key={resource.email}
              resource={resource}
              isSelected={true}
              isOrderedForm={resource.isOrdered || orderFormSessionId[resource.email?.toLowerCase()]}
            />
          ))}
        </VStack>

        {/* Find Available Time */}
        <FindAvailableTime />

        {/* Meeting Type */}
        <SelectMeetingType />
      </VStack>

      {/* Navigate Search */}
      <NavigateSearch />
    </VStack>
  );
};

export default SelectedResources;
